import { mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('menu', ['productsMap'])
    },
    methods: {
        ...mapActions('cart', ['addProductToCart']),
        async handleStoryCtaAction({ type, data }) {
            try {
                switch (type) {
                    case 'add_to_basket':
                        await this.handleAddToBasket(data);
                        break;
                    case 'view_item':
                        await this.handleViewItem(data);
                        break;
                    case 'view_category':
                        await this.handleViewCategory(data);
                        break;
                    case 'external_url':
                        this.handleExternalUrl(data);
                        break;
                    default:
                        console.warn('Unknown CTA type:', type);
                }
            } catch (error) {
                console.error('Error handling story CTA:', error);
                this.$notify({
                    group: 'Story',
                    title: this.$t('storyCta.error'),
                    text: this.$t('storyCta.failedToPerformAction'),
                    type: 'error'
                });
            }
        },
        async handleAddToBasket(data) {
            const { productId, quantity = 1 } = data;

            if (!productId) {
                console.error('No product ID provided for add_to_basket CTA');
                return;
            }

            const product = this.productsMap?.[productId];

            if (!product) {
                this.$notify({
                    group: 'Story',
                    title: this.$t('storyCta.productNotFound'),
                    text: this.$t('storyCta.productNoLongerAvailable'),
                    type: 'error'
                });
                return;
            }

            if (product.modifierGroups && product.modifierGroups.length > 0) {
                this.$emit('close-viewer');
                this.$modal.show('item-modal', { item: product });
            } else {
                await this.addProductToCart([product, quantity, [], 'story']);

                this.$notify({
                    group: 'Story',
                    title: this.$t('storyCta.addedToBasket'),
                    text: this.$t('storyCta.productAddedToBasket', {
                        productName: product.name
                    }),
                    type: 'success'
                });
            }
        },
        async handleViewItem(data) {
            const { productId } = data;

            if (!productId) {
                console.error('No product ID provided for view_item CTA');
                return;
            }

            const product = this.productsMap?.[productId];

            if (!product) {
                this.$notify({
                    group: 'Story',
                    title: this.$t('storyCta.productNotFound'),
                    text: this.$t('storyCta.productNoLongerAvailable'),
                    type: 'error'
                });
                return;
            }

            this.$emit('close-viewer');
            this.$modal.show('item-modal', { item: product });
        },
        async handleViewCategory(data) {
            const { categoryId } = data;

            if (!categoryId) {
                console.error('No category ID provided for view_category CTA');
                return;
            }

            this.$emit('close-viewer');
            this.$router.push({
                name: 'menu',
                hash: `#category-${categoryId}`
            });
        },
        handleExternalUrl(data) {
            const { url } = data;

            if (!url) {
                console.error('No URL provided for external_url CTA');
                return;
            }

            this.$emit('close-viewer');
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    }
};
